import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import windowDimensionState from "../../state/ui/windowDimensionState";
import activeModalState from "../../state/ui/activeModalState";

export default function BaseModal ({children, title, show, center, autoHeight, large, extraLarge, fullHeight, showTitle, titleCloseButton}){

    const windowDimensions = useRecoilValue(windowDimensionState);
    const [activeModal, setShowModal] = useRecoilState(activeModalState);

    return (
        show ?
        <div 
            className={`modal absolute z-50 w-full modal-mobile ${fullHeight ? 'h-full':''} ${center ? 'right-0 left-0 top-0 bottom-0 bg-black bg-opacity-50 flex':'right-0 md:right-2 md:w-11/12'}`}
        >

            <div className={`modal-box ${extraLarge ? 'extraLarge':''} ${large ? 'large':''} ${center ? 'center':''}`}>

                { title &&
                    <div className={`relative px-4 py-3 border-b border-gray-400 border-opacity-25 flex-row justify-center ${showTitle ? 'flex':'hidden md:flex'}`}>
                        <h1 className="font-bold">{title}</h1>
                        {titleCloseButton && 
                            <button onClick={() => setShowModal('')} className="absolute top-0 bottom-0 right-0 px-6">
                                <i className="fas fa-times text-lg fa-fw" />
                            </button>
                        }
                    </div>
                }

                <div 
                    className="relative p-4 overflow-y-scroll custom-scrollbar-dark modal-content" 
                    style={{ 
                        // "--modal-height": (windowDimensions.height-(0.5625 * windowDimensions.width)-133)
                        height: autoHeight ? 'auto':(windowDimensions.width < 768 ? (windowDimensions.height-(0.5625 * windowDimensions.width)-130):'auto')
                    }}
                >
                    {children}
                </div>

            </div>

        </div>
        :
        null
    )
}
